"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { GlassStatusCard } from "@/components/ui/glass-status-card";
interface ErrorBoundaryProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
export default function AuthError({
  error,
  reset
}: ErrorBoundaryProps) {
  useEffect(() => {
    console.error("Auth error boundary caught:", error);
    Sentry.captureException(error);
  }, [error]);
  return <GlassStatusCard hardNavigate eyebrow="Sign-in error" title="Authentication error" description="Something went wrong during the authentication flow." devDetail={process.env.NODE_ENV === "development" ? error.message : undefined} actions={[{
    label: "Try again",
    onClick: reset,
    variant: "primary"
  }, {
    label: "Back to sign in",
    href: "/auth",
    variant: "secondary"
  }, {
    label: "Go home",
    href: "/",
    variant: "secondary"
  }]} data-sentry-element="GlassStatusCard" data-sentry-component="AuthError" data-sentry-source-file="error.tsx" />;
}